// Admin routes for P6-C (APPS-04/05, INTEGRATION-01…05, NOTIFY-03 SMS, STORE-03, ORG-02). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1. Pages are code-split (lazyRouteComponent) like the catalog,
// so the services, Conversations and Daraz screens never weigh on the shell's first load.
import { createRoute, lazyRouteComponent, type AnyRoute } from "@tanstack/react-router";

const developers = () => import("../integrations/DevelopersPage");
const mcp = () => import("../integrations/McpPage");
const integrations = () => import("../integrations/IntegrationsPage");
const importMarket = () => import("../services/ImportMarketPage");
const digitalMarketing = () => import("../services/DigitalMarketingPage");
const ads = () => import("../services/AdsPage");
const courses = () => import("../services/CoursesPage");
const conversations = () => import("../conversations/ConversationsPage");
const daraz = () => import("../daraz/DarazPage");
const sms = () => import("../services/SmsServicePage");

export function integrationsRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: ReturnType<typeof lazyRouteComponent>) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    // Developer (D-090): API keys · MCP server · Webhooks.
    at("/$org/$store/apps/developers", lazyRouteComponent(developers, "ApiKeysPage")),
    at("/$org/$store/apps/developers/mcp", lazyRouteComponent(mcp, "McpPage")),
    at("/$org/$store/apps/developers/webhooks", lazyRouteComponent(developers, "WebhooksPage")),
    at("/$org/$store/apps/integrations", lazyRouteComponent(integrations, "IntegrationsPage")),
    // NOTIFY-001 SMS Service, under Adyvance Services (owner, 2026-10-21; rebuilt 2026-10-23, D-052).
    at("/$org/$store/services/sms", lazyRouteComponent(sms, "SmsServicePage")),
    // Digital Marketing: ad platform cards (owner, 2026-10-23).
    at(
      "/$org/$store/services/digital-marketing",
      lazyRouteComponent(digitalMarketing, "DigitalMarketingPage"),
    ),
    // SERVICES-001 Meta and Google Ads run by Adyvance (owner, 2026-10-23; D-053).
    at("/$org/$store/services/digital-marketing/meta", lazyRouteComponent(ads, "MetaAdsPage")),
    at("/$org/$store/services/digital-marketing/google", lazyRouteComponent(ads, "GoogleAdsPage")),
    // SERVICES-001 Courses: how-to videos (owner, 2026-10-24; D-054).
    at("/$org/$store/services/courses", lazyRouteComponent(courses, "CoursesPage")),
    // CONV-001 Conversations: one inbox for the website chat, Messenger, Instagram, WhatsApp and
    // TikTok (owner, 2026-10-24; D-055).
    at("/$org/$store/conversations", lazyRouteComponent(conversations, "ConversationsPage")),
    // INTEGRATION-07 Daraz: the shop's Daraz store (owner, 2026-10-24; D-056).
    at("/$org/$store/daraz", lazyRouteComponent(daraz, "DarazPage")),
    // SERVICES-001 Import Marketplace (owner, 2026-10-23).
    at(
      "/$org/$store/services/import-marketplace",
      lazyRouteComponent(importMarket, "ImportMarketPage"),
    ),
    // ORG-02 business verification is the Verification tab of Settings → Organization (modules/settings.tsx).
  ];
}
